import { useEffect, useState } from "react";
import moment from "moment";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import PrintDocumentTemplate from "../../../../Components/PrintDocumentTemplate/PrintDocumentTemplate";
import BMXSectionHeader from "../../../../Components/BMXSectionHeader/BMXSectionHeader";
import BMXServiceDetailsBox from "../../../../Components/BMXServiceDetailsBox/BMXServiceDetailsBox";
import InvoiceTable from "../../../Components/Tables/ServiceInvoiceTable/ServiceInvoiceTable";
import { get } from "lodash";
import "./Servicecard.scss";

import { useTranslation } from "react-i18next";

const ServicecardComponent = ({ logo }) => {
  return (
    <div className="LogoArea">
      {logo ? <img className="Logo" alt="Logo" src={logo} /> : null}
    </div>
  );
};

export const Servicecard = () => {
  const { t } = useTranslation();
  const [logo, setLogo] = useState(null);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      const settingsResp = await GlobalAuthFetch({ path: "/settings", disableError: true });
      const data = settingsResp?.payload?.data || [];
      const formattedSettings = data.reduce((acc, item) => {
        acc[item.name] = item.value;
        return acc;
      }, {});
      setLogo(formattedSettings.LOGO);
      setSettings(formattedSettings);
    };

    loadData();
  }, []);

  if (!settings) return null;

  const serviceOrderData = JSON.parse(sessionStorage.getItem("serviceOrderData"));

  const serviceColumns = [
    { key: "name", label: `${t("global:service.name")}` },
    { key: "netPrice", label: `${t("global:service.netPrice")}` },
    { key: "vat", label: `${t("global:service.vat")}` },
    { key: "vatValue", label: `${t("global:service.vatValue")}` },
    { key: "grossPrice", label: `${t("global:service.grossPrice")}` },
  ];
  const productColumns = [
    { key: "product", label: `${t("global:service.product")}` },
    { key: "quantity", label: `${t("global:service.quantity")}` },
    { key: "unit", label: `${t("global:service.unit")}` },
    { key: "vat", label: `${t("global:service.vat")}` },
    { key: "netPrice", label: `${t("global:service.netPrice")}` },
    { key: "grossPrice", label: `${t("global:service.grossPrice")}` },
  ];
  const formatPLN = v => `${v.toFixed(2)} PLN`;

  const VAT = 0.23;
  const transportNet = 0;

  const productData = serviceOrderData?.parts?.map((part, index) => {
    const quantity = Number(part.quantity) || 0;
    const unitPrice = Number(part.price) || 0;
    const netValue = quantity * unitPrice;
    const grossValue = netValue * (1 + VAT);

    return {
      id: index + 1,
      product: part.name,
      quantity,
      unit: t("global:service.pcs"),
      vat: `${(VAT * 100)}%`,
      netPrice: formatPLN(netValue),
      grossPrice: formatPLN(grossValue),
    };
  }) || [];


  const serviceNet =
    (Number(serviceOrderData?.device?.printerModel?.servicePrice?.diagnosticsPrice) || 0) * (Number(serviceOrderData.diagnosticsTimeCounter) || 0) +
    (Number(serviceOrderData?.device?.printerModel?.servicePrice?.installationPrice) || 0) * (Number(serviceOrderData.implementationTimeCounter) || 0) +
    (Number(serviceOrderData?.device?.printerModel?.servicePrice?.itServicePrice) || 0) * (Number(serviceOrderData.itServiceTimeCounter) || 0) +
    (Number(serviceOrderData?.device?.printerModel?.servicePrice?.surveyPrice) || 0) * (Number(serviceOrderData.inspectionTimeCounter) || 0) +
    (Number(serviceOrderData?.device?.printerModel?.servicePrice?.repairPrice) || 0) * (Number(serviceOrderData.repairTimeCounter) || 0);

  const partsNetto = serviceOrderData?.parts?.reduce((sum, part) => {
    const qty = Number(part.quantity) || 0;
    const price = Number(part.price) || 0;
    return sum + qty * price;
  }, 0) || 0;



  const serviceData = [
    { id: 1, name: `${t("global:service.parts")}`, net: partsNetto },
    { id: 2, name: `${t("global:service.serviceSupport")}`, net: serviceNet },
    { id: 3, name: `${t("global:service.transport")}`, net: transportNet },
  ].map(({ id, name, net }) => ({
    id,
    name,
    netPrice: formatPLN(net),
    vat: "23%",
    vatValue: formatPLN(net * VAT),
    grossPrice: formatPLN(net * (1 + VAT)),
  }));

  const emailToSendList = get(serviceOrderData,"device.client.representatives",[]).map(el=> ({label: `${el.name} ${el.lastname}`, value: el.email, uuid: el.uuid})).filter(el=> Boolean(el.value));
  
  return (
    <PrintDocumentTemplate
      fileName={`${t("global:service.serviceCard")}`}
      documentType="ServiceOrder"
      usersToSendEmail={emailToSendList}

    >
      {[
        <div key="page1">
          <div className="TargetPrintServicecardAreaFrom">
            <div className="HeaderArea">
              <ServicecardComponent logo={logo} />
              <div className="DateArea">
                {/* index */}
                <span>{`${t("global:service.id")}`} {serviceOrderData?.index}</span>
                {/* Data przyjęcia */}
                <span>{`${t("global:service.dateOfAdmission")}`} {moment(serviceOrderData?.createdAt).format("DD-MM-YYYYr")}</span>
                {/* Planowana data usługi */}
                <span>{`${t("global:service.plannedServiceDate")}`} {moment(serviceOrderData?.plannedServiceDateTime).format("DD-MM-YYYYr")}</span>
                {/* Data realizacji usługi */}
                <span>{`${t("global:service.dateOfService")}`} {moment(serviceOrderData?.startDateTime).format("DD-MM-YYYYr")}</span>
              </div>
            </div>

            <div className="mt-4">
              <BMXSectionHeader text={`${t("global:service.serviceCard")}`} />
            </div>

            <div className="CardDetails">
              <div className="leftColumn">
                <div className="title upper">{`${t("global:service.seller")}`}</div>
                <div className="text">{settings.COMPANY_NAME}</div>
                <div className="text">{`${t("global:service.str")}`} {settings.COMPANY_ADDRESS}, {settings.COMPANY_POST_CODE} {settings.COMPANY_CITY}</div>
                <div className="text">{`${t("global:service.nip")}`} {settings.NIP}</div>
                <div className="text">{settings.COMPANY_EMAIL}</div>
                <div className="text">{settings.WEBSITE}</div>

                <div className="section">
                  {/* Przyjęcie zlecenia */}
                  <div className="text">{`${t("global:service.acceptanceOfTheOrder")}`} {serviceOrderData?.createdBy?.firstName} {serviceOrderData?.createdBy?.lastName}</div>
                  {/* Technik realizujący */}
                  <div className="text">{`${t("global:service.implementingTechnician")}`} {serviceOrderData?.technicianOrTeamLeader?.firstName} {serviceOrderData?.technicianOrTeamLeader?.lastName}</div>
                </div>
              </div>

              <div className="rightColumn">
                {/* ID Klient */}
                <div className="title upper">{`${t("global:service.client")}`} {serviceOrderData?.device?.client?.contactId}</div>
                {/* Klient nazwa */}
                <div className="field">{serviceOrderData?.device?.client?.name}</div>
                {/* Adres klienta */}
                <div className="field">{`${t("global:service.str")}`}{serviceOrderData?.device?.client?.street} {serviceOrderData?.device?.client?.houseNumber} {serviceOrderData?.device?.client?.houseNumber} {serviceOrderData?.device?.client?.postCode} {serviceOrderData?.device?.client?.post}</div>
                {/* Nip klienta */}
                <div className="field">{`${t("global:service.NIP")}`}</div>
                {/* Osoba zlecająca u klienta  */}
                <div className="field">{`${t("global:service.ordered")}`} {serviceOrderData?.requester?.name} {serviceOrderData?.requester?.lastname}</div>
                {/* Telefon klienta */}
                <div className="field">{`${t("global:service.phn")}`} {serviceOrderData?.requester?.phoneNumber}</div>
                {/* email klienta */}
                <div className="field">{`${t("global:service.email")}`} {serviceOrderData?.requester?.email}</div>
                {/* Lokalizacja klienta  */}
                <div className="field">{`${t("global:service.location")}`} {serviceOrderData?.device?.addressFloor}</div>

                <div className="section">
                  {/* Przedmiot usługi */}
                  <div className="title upper">{`${t("global:service.deviceService")}`}</div>
                  {/* Przedmiot usługi */}
                  <div className="text">{serviceOrderData?.device?.printerModel?.manufacturer?.entryName} {serviceOrderData?.device?.printerModel?.modelName} {`${t("global:service.sn")}`} {serviceOrderData?.device?.serialNumber}</div>
                </div>

                <div className="section">
                  <div className="d-flex">
                    {/* Podstawa serwisu: */}
                    <div className="title">{`${t("global:service.serviceBase")}`}</div>
                    {/* Podstawa serwisu: */}
                    <div className="field">{serviceOrderData?.serviceBase?.entryName}</div>
                  </div>
                  <div className="d-flex">
                    {/* Gwarancja */}
                    <div className="title">{`${t("global:service.warranty")}`}</div>
                    {/* Gwarancja */}
                    <div className="field">{serviceOrderData?.warranty ? `${t("global:service.yes")}` : `${t("global:service.no")}`}</div>
                  </div>
                  <div className="d-flex">
                    {/* Licznik urządzenia mono: */}
                    <div className="title">{`${t("global:service.monoCounter")}`}</div>
                    {/* Licznik urządzenia mono: */}
                    <div className="field">{serviceOrderData?.counter1}</div>
                  </div>
                  <div className="d-flex">
                    {/* Kontynuacja */}
                    <div className="title">{`${t("global:service.continuation")}`}</div>
                    {/* Kontynuacja */}
                    <div className="field">{serviceOrderData?.continuation ? `${t("global:service.yes")}` : `${t("global:service.no")}`}</div>
                  </div>
                  <div className="d-flex">
                    {/* Licznik urządzenia kolor */}
                    <div className="title">{`${t("global:service.colorCounter")}`}</div>
                    {/* Licznik urządzenia kolor */}
                    <div className="field">{serviceOrderData?.counter2}</div>
                  </div>
                  <div className="d-flex">
                    {/* Pakiet usług */}
                    <div className="title">{`${t("global:service.ServicePackage")}`}</div>
                    {/* Pakiet usług */}
                    <div className="field">{serviceOrderData?.device?.printerModel?.servicePrice?.name}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="serviceDetails">
              {/* Opis problemu */}
              <BMXServiceDetailsBox title={`${t("global:service.descriptionOfTheProblem")}`} content={serviceOrderData?.problemDescriptionsDictionary.map(item => item.entryName).join(' ')} />
              {/* Do wykonania */}
              <BMXServiceDetailsBox title={`${t("global:service.toBeDone")}`} content={serviceOrderData?.tasksDictionary.map(item => item.entryName).join(' ')} />
              {/* Opis logistyka */}
              <BMXServiceDetailsBox title={`${t("global:service.logisticsDescription")}`} content={serviceOrderData?.additionalLogisticsDescription} />
              {/* Uwagi z ostatniej interwencji */}
              <BMXServiceDetailsBox title={`${t("global:service.commentsFromTheLastIntervention")}`} content={serviceOrderData?.lastInterventionNotes} />
              {/* Opis technika serwisu */}
              <BMXServiceDetailsBox title={`${t("global:service.serviceTechnicianDescription")}`} content={serviceOrderData?.interventionScope} />
            </div>

            <div className="footer">
              <span>{settings.WEBSITE}</span>
            </div>
          </div>
        </div>,
        serviceOrderData?.assignPrices ? <div key="page2">
          <div className="TargetPrintServiceorderAreaFrom">
            <div className="HeaderArea">
              <ServicecardComponent logo={logo} />
              <div className="DateArea">
                {/* index */}
                <span>{`${t("global:service.id")}`} {serviceOrderData?.index}</span>
                {/* Data przyjęcia */}
                <span>{`${t("global:service.dateOfAdmission")}`} {moment(serviceOrderData?.createdAt).format("DD-MM-YYYYr")}</span>
                {/* Planowana data usługi */}
                <span>{`${t("global:service.plannedServiceDate")}`} {moment(serviceOrderData?.plannedServiceDateTime).format("DD-MM-YYYYr")}</span>
                {/* Data realizacji usługi */}
                <span>{`${t("global:service.dateOfService")}`} {moment(serviceOrderData?.startDateTime).format("DD-MM-YYYYr")}</span>
              </div>
            </div>

            <div className="mt-4">
              <BMXSectionHeader text={`${t("global:service.serviceCard")}`} />
            </div>

            <div className="mt-5 print-padding">
              <InvoiceTable rows={serviceData} columns={serviceColumns} />
            </div>

            <div className="mt-4 print-padding">
              <InvoiceTable rows={productData} columns={productColumns} />
            </div>

            <div className="footer">
              <span>{settings.WEBSITE}</span>
            </div>
          </div>
        </div> : null

      ]}
    </PrintDocumentTemplate>
  );
};
